interface EmbeddedEntryWrapperProps {
  classArray?: string[];
  extraClasses?: string;
  childComponent: React.ReactNode;
}
export const embeddedEntryDefaultClasses = `mb-8 md:mb-8 lg:mb-8 mx-auto`

export const EmbeddedEntryWrapper = ( props : EmbeddedEntryWrapperProps) => {
  const defaultClasses = embeddedEntryDefaultClasses
  const { classArray, extraClasses } = props

  // let classString = defaultClasses
  // if(classArray && classArray.length > 0) { classString = classArray.join(' ') }
  const classString = (classArray && classArray.length > 0) ? classArray.join(' ') : defaultClasses

  const classNameFinal = `${classString} ${extraClasses}`

  return (
    <div className={classNameFinal}>
      {props?.childComponent}
    </div>
  )
}